// Minimal classNames merge. Keeps the skill's `cn()` ergonomics without
// pulling in clsx/tailwind-merge for a prototype.
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
